import { http, HttpResponse, delay } from 'msw';

import {
  getNotificationsResponse,
  getUnseenNotificationsCountResponse,
} from '../data/notificationsData';

export const notificationsHandlers = [
  http.get(`*/v1/notifications/count/unseen`, async () => {
    await delay(200);
    return HttpResponse.json(
      getUnseenNotificationsCountResponse(getNotificationsResponse.results),
      { status: 200 }
    );
  }),
  http.get(`*/v1/notifications`, async ({ request }) => {
    const url = new URL(request.url);
    const limitParam = url.searchParams.get('limit');
    const limit = limitParam
      ? parseInt(limitParam)
      : (getNotificationsResponse.total ?? 0);

    const offsetParam = url.searchParams.get('offset');
    const offset = offsetParam ? parseInt(offsetParam) : 0;

    await delay(200);
    return HttpResponse.json(
      {
        ...getNotificationsResponse,
        results: getNotificationsResponse.results.slice(offset, offset + limit),
      },
      { status: 200 }
    );
  }),
  http.patch(`*/v1/notifications`, async ({ request }) => {
    const body = (await request.json()) as { notification_ids?: string[] };
    const notificationIds = body?.notification_ids ?? [];

    notificationIds.forEach((id: string) => {
      const index = getNotificationsResponse.results.findIndex(
        n => n.id === id
      );

      if (index >= 0) {
        getNotificationsResponse.results[index].seen_at =
          new Date().toDateString();
      }
    });

    await delay(200);
    return new HttpResponse(null, { status: 200 });
  }),
];
